export default function (path) {
  return (resolve) => {
    require([`../components/${path}`], resolve)
  }
}



// WEBPACK FOOTER //
// ./src/router/component-resolver.js